import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-stage energy-glow tech-grid py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="oudslv49x1tk">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12uew7ibxancq">
        <div className="text-center" data-id="element-49" data-mp="xu0mlvuob5cl">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-50" data-mp="xszarp5u2ett">
            El próximo lunes puedes seguir improvisando…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-51" data-mp="17qvl4eqy55qv">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hh83c0bagmtu">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark flex items-center gap-3 rounded-lg border-l-4 border-gold px-4 py-3 text-sm font-semibold text-onDark" data-id="element-53" data-mp="1vgzl8c4xend4" data-mpi={index}>
              <span className="font-display text-sageGlow" aria-hidden="true" data-id="element-54" data-mp="2c98jd4y885bd">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2la6s20jm110a">
          <p className="leading-relaxed text-mutedDark" data-id="element-56" data-mp="2qa1glxfwxei6">
            El Mega Pack Geología Listo no te convierte en mejor docente. Ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-57" data-mp="2v34daefzl42l">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}